'use strict';

require('regenerator-runtime/runtime');
let abcAuthModule = require('./auth/index');
let abcCoreModule = require('./core/index');
let abcProductModule = require('./product/index');
let abcOrderModule = require('./order/index');
let abcAccountModule = require('./account/index');
let EventBus = require('./core/EventBus');
let shoppingList =require('./shoppingList');

module.exports = function(param){
    if(typeof param !== "object"){
        param = {};
    }
    // providing option to inject Custom EventBus
    if(param && typeof param._EventBus !== "object"){
        param._EventBus = EventBus;
    }
    const AbcModules = {
        auth: abcAuthModule(param),
        core: abcCoreModule(param),
        EventBus: EventBus,
        product: abcProductModule(param),
        order: abcOrderModule(param),
        account: abcAccountModule(param),
        shoppingList:shoppingList(param),
        version: {
            ABC_VERSION: ((typeof ABC_VERSION !== 'undefined') ? ABC_VERSION : null), 
            RULE_ENGINE_VERSION: ((typeof RULE_ENGINE_VERSION !== 'undefined') ? RULE_ENGINE_VERSION : null)
        }
    };

    return AbcModules;
};

// Allow use of default import syntax in TypeScript
//module.exports.default = AbcModules;


// WEBPACK FOOTER //
// ./src/index.js